export default __webpack_public_path__ + "static/media/refresh.5058161d.svg";